import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';

const StatusCard = ({
    classes,
    heading = '',
    text = '',
    dropdownItems = [],
    hasPermission = false
}) => {
    return (
        <div className="my-2 clienplugin-status">
            <div className={`sc-rounded sc-shadow d-flex justify-content-between ${classes}`}>
                <div className="w-100 text-12 p-2 bg-dark-opacity-3 sc-rounded text-center">
                    <h6 className="text-12">{heading}</h6>
                    <span className="text-9">{text}</span>
                </div>
                <div>
                    {hasPermission && (
                        <UncontrolledDropdown>
                            <DropdownToggle
                                nav
                                className="text-light"
                                style={{
                                    position: 'absolute',
                                    right: '0px',
                                }}>
                                <FontAwesomeIcon icon={faEllipsisV} size="lg" />
                            </DropdownToggle>
                            <DropdownMenu right>
                                {dropdownItems.map(
                                    (
                                        { itemAction: action, itemText: text },
                                        index
                                    ) => (
                                        <DropdownItem
                                            className=""
                                            key={index}
                                            onClick={action}>
                                            {text || ''}
                                        </DropdownItem>
                                    )
                                )}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatusCard;